import { render } from "./TestDrive.vue?vue&type=template&id=73d9a2c0"
import script from "./TestDrive.vue?vue&type=script&lang=js"
export * from "./TestDrive.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__